import { useEffect, useState } from 'react';
import { MOCK } from '../lib/supabase.js';
import * as db from '../lib/data.js';
import { Modal, Fld } from './Modals.jsx';

// ผู้จัดทำเอกสาร (ต่อ user) — โหลด/แก้ ชื่อ+ตำแหน่งของตัวเอง เพื่อเติมลงเอกสาร
export function useSigner() {
  const [signer, setSigner] = useState(null);
  const load = () => { if (!MOCK) db.getMySigner().then(setSigner).catch(() => {}); };
  useEffect(load, []);
  return [signer, load];
}

// ปุ่ม noprint บนหน้าเอกสาร: โชว์ชื่อผู้จัดทำปัจจุบัน + กดแก้ได้
export function SignerEditor({ signer, onSaved }) {
  const [open, setOpen] = useState(false);
  if (MOCK) return null;
  const label = signer?.full_name
    ? `ผู้จัดทำ: ${signer.full_name}${signer.job_title ? ' · ' + signer.job_title : ''}`
    : '＋ ตั้งชื่อผู้จัดทำ';
  return (
    <>
      <button className="btn2" title="ชื่อ/ตำแหน่งของคุณ — เติมลงช่องผู้จัดทำในเอกสารทุกใบ" onClick={() => setOpen(true)}>
        {label} ✎
      </button>
      {open && <SignerModal signer={signer} onClose={() => setOpen(false)}
        onSaved={() => { onSaved(); setOpen(false); }}/>}
    </>
  );
}

function SignerModal({ signer, onClose, onSaved }) {
  const [name, setName] = useState(signer?.full_name ?? '');
  const [title, setTitle] = useState(signer?.job_title ?? '');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError(null);
    try { await db.saveMySigner(name.trim(), title.trim()); onSaved(); }
    catch (er) { setError(er.message ?? String(er)); setBusy(false); }
  };
  return (
    <Modal title="ข้อมูลผู้จัดทำเอกสาร"
      sub="ชื่อ/ตำแหน่งของคุณ — ระบบเก็บไว้แล้วเติมลงช่องผู้จัดทำ/ผู้ยื่นในเอกสารทุกใบให้อัตโนมัติ (แต่ละคนมีของตัวเอง)"
      onClose={onClose}>
      <form onSubmit={submit}>
        <Fld label="ชื่อ-นามสกุล"><input value={name} onChange={e => setName(e.target.value)} placeholder="เช่น ปริญ ตรอน" autoFocus/></Fld>
        <Fld label="ตำแหน่ง (เว้นได้)"><input value={title} onChange={e => setTitle(e.target.value)} placeholder="เช่น เจ้าหน้าที่นำเข้า"/></Fld>
        {error && <div className="ferr">{error}</div>}
        <div className="mfoot">
          <button type="button" className="btn2" onClick={onClose}>ปิด</button>
          <button className="btn1" disabled={busy}>{busy ? 'กำลังบันทึก…' : 'บันทึก'}</button>
        </div>
      </form>
    </Modal>
  );
}
